var map = {
	"./favicon.ico": "91a0",
	"./faviconold.ico": "28a8",
	"./logo.png": "a4ef",
	"./logo.svg": "ed29",
	"./logo3.png": "0ba6",
	"./logo3Dark.png": "4267",
	"./logooffice1.png": "a7f3",
	"./logooffice3.png": "d4c8",
	"./logooffice4.png": "d690",
	"./logoold.png": "9456",
	"./vuexy-logo.png": "d120"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d47a";